<template>
  <div>
    <div v-if="noSubscription" class="overlay-section">
      <div class="overlay-header">
        <div class="premium">
          <v-icon large>loop</v-icon>
        </div>
        <h2 style="text-align: center">MATCH-ABOS</h2>
        <p>
          <b
            >Mit den Match-Abos kannst du während der gesamten Laufzeit unbegrenzt
            Spieler und Trainer matchen sowie Vereine connecten - umso länger dein
            Match-Abo läuft, desto schneller wächst dein Talentportfolio.</b
          >
        </p>
      </div>
      <StripeSubscription />
    </div>

    <div v-else class="match">
      <v-tabs
        v-model="tab"
        class="tabs"
        fixed-tabs
        background-color="white"
        slider-color="light-green accent-4"
      >
        <v-tab href="#Spieler">Spieler</v-tab>
        <v-tab href="#Trainers">Trainer</v-tab>
        <v-tab href="#Teams">Vereine</v-tab>

        <v-tabs-items :touchless="true">
          <v-tab-item value="Spieler">
            <v-list>
              <v-list-group no-action>
                <template v-slot:activator>
                  <div class="history-wrapper list-name">
                    <h3 v-text="'Filter auswählen'"></h3>
                  </div>
                </template>

                <PlayerFilters
                  @reset-filters="resetFilters"
                  :player_switches.sync="player_switches"
                  :user_data.sync="user_data"
                />
              </v-list-group>
            </v-list>
            <div class="full-spinner" v-if="loading">
              <v-progress-circular indeterminate color="green"></v-progress-circular>
            </div>
            <div class="match-results" v-else>
              <ResultsList
                :count="allFilteredPlayers.length"
                :user-data="user_data"
                type="view_player"
                :results="filteredPlayers"
                @switch-watchlist="
                  updateFilters('watchlist', $event, 'player_switches')
                "
                @switch-matched="updateFilters('matched', $event, 'player_switches')"
                @switch-de-matched="
                  updateFilters('dematched', $event, 'player_switches')
                "
                @switch-avatar="updateFilters('with_avatar', $event, 'player_switches')"
                @switch-active-account="
                  updateFilters('account_active', $event, 'player_switches')
                "
                @open-profile="openProfile"
                @name-searched="filterName($event, 'players')"
              />
              <div class="load-more-button__wrapper">
                <v-btn
                  v-if="allFilteredPlayers.length > 20"
                  @click="limits.players += 20"
                  class="menu-button main main-small"
                >
                  Mehr anzeigen
                </v-btn>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item value="Trainers">
            <v-list>
              <v-list-group no-action>
                <template v-slot:activator>
                  <div class="history-wrapper list-name">
                    <h3 v-text="'Filter auswählen'"></h3>
                  </div>
                </template>
                <TrainerFilters
                  @reset-filters="resetFilters"
                  :trainer_switches.sync="trainer_switches"
                  :user_data.sync="user_data"
                />
              </v-list-group>
            </v-list>
            <div class="full-spinner" v-if="loading">
              <v-progress-circular indeterminate color="green"></v-progress-circular>
            </div>
            <div v-else class="match-results">
              <ResultsList
                type="view_trainer"
                :results="filteredTrainers"
                :count="allFilteredTrainers.length"
                :user-data="user_data"
                @switch-watchlist="
                  updateFilters('watchlist', $event, 'trainer_switches')
                "
                @switch-matched="updateFilters('matched', $event, 'trainer_switches')"
                @switch-de-matched="
                  updateFilters('dematched', $event, 'trainer_switches')
                "
                @switch-avatar="
                  updateFilters('with_avatar', $event, 'trainer_switches')
                "
                @switch-active-account="
                  updateFilters('account_active', $event, 'trainer_switches')
                "
                @open-profile="openProfile"
                @name-searched="filterName($event, 'trainers')"
              />
              <div class="load-more-button__wrapper">
                <v-btn
                  v-if="allFilteredTrainers.length > 20"
                  @click="limits.trainers += 20"
                  class="menu-button main main-small"
                >
                  Mehr anzeigen
                </v-btn>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item value="Teams">
            <v-list>
              <v-list-group no-action>
                <template v-slot:activator>
                  <div class="history-wrapper list-name">
                    <h3 v-text="'Filter auswählen'"></h3>
                  </div>
                </template>

                <TeamFilters
                  @reset-filters="resetFilters"
                  :team_switches.sync="team_switches"
                  :user_data.sync="user_data"
                />
              </v-list-group>
            </v-list>
            <div class="full-spinner" v-if="loading">
              <v-progress-circular indeterminate color="green"></v-progress-circular>
            </div>
            <div v-else class="match-results">
              <ResultsList
                :user-data="user_data"
                type="view_team"
                :results="filteredTeams"
                :count="allFilteredTeams.length"
                :teamResults="true"
                :bluryResults="noSubscriptionFreeMatches"
                @switch-watchlist="updateFilters('watchlist', $event, 'team_switches')"
                @switch-matched="updateFilters('matched', $event, 'team_switches')"
                @switch-de-matched="updateFilters('dematched', $event, 'team_switches')"
                @switch-avatar="updateFilters('with_avatar', $event, 'team_switches')"
                @switch-active-account="
                  updateFilters('account_active', $event, 'team_switches')
                "
                @open-profile="openProfile"
                @name-searched="filterName($event, 'teams')"
              />
              <div class="load-more-button__wrapper">
                <v-btn
                  v-if="allFilteredTeams.length > 20"
                  @click="limits.teams += 20"
                  class="menu-button main main-small"
                >
                  Mehr anzeigen
                </v-btn>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>

      <MatchSheetPlayer
        v-if="tab === 'Spieler' && currentPlayer.id"
        :selectedProfile="currentPlayer"
        @close="view_player = false"
        :show="view_player"
      ></MatchSheetPlayer>

      <MatchSheetTrainer
        v-if="tab === 'Trainers' && currentPlayer.id"
        :selectedProfile="currentPlayer"
        @close="view_trainer = false"
        :show="view_trainer"
      ></MatchSheetTrainer>

      <MatchSheetTeam
        v-if="tab === 'Teams' && currentPlayer.id"
        :selectedProfile="currentPlayer"
        @close="view_team = false"
        :show="view_team"
      ></MatchSheetTeam>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex';
import { db } from '@/db';
import MatchSheetPlayer from '@/components/match/PlayerSheet';
import MatchSheetTeam from '@/components/match/TeamSheet';
import MatchSheetTrainer from '@/components/match/TrainerSheet';
import PlayerFilters from '@/components/filters/PlayerFilters';
import TrainerFilters from '@/components/filters/TrainerFilters';
import TeamFilters from '@/components/filters/TeamFilters';
import filters from '../../mixins/filters';
import ResultsList from '../../components/lists/Results';
import StripeSubscription from '../payment/StripeSubscription';

import {
  playerConverter,
  teamConverter,
  trainerConverter,
} from '../../helpers/firebase-converters';

export default {
  name: 'match',

  components: {
    MatchSheetPlayer,
    MatchSheetTeam,
    MatchSheetTrainer,
    PlayerFilters,
    TrainerFilters,
    TeamFilters,
    ResultsList,
    StripeSubscription,
  },

  mixins: [filters],

  data: () => ({
    dialog: false,
    currentPlayer: {
      settings: {},
    },
    view_team: false,
    view_trainer: false,
    view_player: false,
  }),

  computed: {
    ...mapState(['user_data', 'subscriptionData']),

    loading() {
      return !(this.players !== null && this.trainers !== null);
    },
  },

  methods: {
    async openProfile(data, type) {
      // if withConverter, get full profile before setting currentPlayer
      this.$store.state.loading = true;

      let collection;
      switch (type) {
        case 'view_player':
          collection = 'users';
          break;
        case 'view_trainer':
          collection = 'trainers';
          break;
        case 'view_team':
          collection = 'teams';
          break;
        default:
          break;
      }

      const fullData = await db
        .collection(collection)
        .doc(data.id)
        .get()
        .then((snap) => snap.data());

      this.currentPlayer = fullData;
      this[type] = true;
      this.$store.state.loading = false;
    },
  },

  created() {
    if (this.user_data.userType !== 'scout') {
      this.$router.push({ name: 'dummyHome' });
    }
    this.tab = this.user_data.selectedTab;
    this.getUserOnlineStatus();
  },

  firestore: {
    players: db
      .collection('users')
      .withConverter(playerConverter)
      .where('name', '!=', '')
      .orderBy('name', 'asc'),
    trainers: db
      .collection('trainers')
      .withConverter(trainerConverter)
      .where('name', '!=', '')
      .orderBy('name', 'asc'),
    teams: db
      .collection('teams')
      .withConverter(teamConverter)
      .where('team_name', '!=', '')
      .orderBy('team_name', 'asc'),
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/components/_match.scss';
</style>
